exports = module.exports = require("../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\nheader .form-inline .search-form button {\r\n     cursor: pointer;\n}\r\n", ""]);

